<template>
  <div class="timeline-item container-item" data-scroll="scroll">    
    <div class="row">
      <div class="col-12 p-0">
        <div class="timeline-wrapper d-none d-sm-none d-md-block" :ref="uid" :id="`container_scroll_${uid}`">

          <div class="timeline-media-container">
            <div :id="`scroll_${uid}_media_item_${ix}`" v-for="(i, ix) in cardText" :key="ix" :class="{'active': ix == 0}" class="timeline-media" :data-card="ix">
                <ImageElement :imageData="imageDataScroll(cardText[ix])" :position="cardText[ix].position" />
                <div v-if="i.imageCredits" class="creditos-picture" :class="cardText[0].position">
                  {{ i.imageCredits }}
                </div>                
            </div>
          </div>

          <div v-for="(i, ix) in cardText" :key="ix" class="timeline-content trigger" :data-card="ix">
            <div v-if="i.text" :class="i.position">
              <div v-html="i.text"></div>
            </div>
          </div>
          
          <div v-for="(i, ix) in cardText" :key="`page_${ix}`" class="timeline-pagination" :data-page="ix">
            <div>
              <span class="circle"></span>             
            </div>
          </div>
        </div> 
        <div class="d-block d-sm-block d-md-none">
          <div :id="`scroll_media_${uid}_media_item_${ix}`" v-for="(i, ix) in cardText" :key="ix" :class="{'active': ix == 0}" :data-card="ix">
            <div class="mb-3">
              <ImageElement :imageData="imageDataScroll(cardText[ix])" :position="cardText[ix].position" />
            </div>
            <div class="caption-mobile" v-html="i.text"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>

  .caption-mobile {
    text-align: left;
    font-family: "Noto Sans";
    padding: 0 15px;
    color: #000;
    font-size: 15px;
  }
</style>

<script>

  import scrollama from 'scrollama'
  import images from '@/mixins/images'

  export default {
    name: 'ScrollText',
    mixins: [images],
    data() {
      return {
        uid: this._uid
      }
    },
    props: {
      cardText: Array
    },
    computed: {
      scroller() {
        return scrollama()
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.initScroll();
      });
    },
    methods: {
      initScroll() {
        this.scroller
          .setup({
            container: `#container_scroll_${this.uid}`,
            graphic: `#container_scroll_${this.uid} .timeline-media-container`,
            step: `#container_scroll_${this.uid} .trigger`,
            offset: 0.85,
            debug: false,
            progress: true
          })
          .onStepEnter(response => {
            Array.from(this.$refs[this.uid].querySelectorAll(`#container_scroll_${this.uid} .timeline-media`)).forEach(e => e.classList.remove(`active`))
            this.$refs[this.uid].querySelector(`#scroll_${this.uid}_media_item_${response.index}`).classList.add(`active`)
          })
      }
    }
  }
</script>
